module.exports = __webpack_public_path__ + "static/media/yakuza-picture-1.995bc74e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/Yakuza/yakuza-picture-1.jpg
// module id = 63
// module chunks = 0